import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/admin/authSlice';
import adminCompaniesReducer from './slices/admin/companySlice';
import adminRoleReducer from './slices/admin/rolesSlice';
import companyRoleReducer from './slices/company/rolesSlice';
import adminStaffReducer from './slices/admin/staffSlice';
import branchReducer from './slices/company/branchSlice';
import branchUserReducer from './slices/company/branchUserSlice';
import supplierReducer from './slices/company/supplierSlice';
import taxesReducer from './slices/company/taxSlices';
import unitsReducer from './slices/company/unitsSlice';
import rawCategoryReducer from './slices/company/rawCategorySlice'; // Adjust the import path if necessary
import rawProductReducer from './slices/company/rawProductSlice'; // Adjust the import path if necessary
import finalProductReducer from './slices/company/finalProductSlice'; // Adjust the import path if necessary
import customerReducer from './slices/company/customerSlice';
import tenderReducer from './slices/company/tenderSlice';
import finalCategoryReducer from './slices/company/finalCategorySlice';
import purchasesReducer from './slices/company/purchasesSlice';
import rawMaterialReducer from './slices/company/rawMaterialSlice';
import taskReducer from "./slices/company/taskSlice";
import billsReducer from "./slices/company/billsSlice";
import creditNotesReducer from "./slices/company/creditNotesSlice"; // Adjust path accordingly
import assetsReducer from "./slices/company/assetsSlice";
import productAttributeReducer from "./slices/company/productAttributeSlice"; // Adjust path accordingly
import brandReducer from './slices/company/brandSlice';
import dispensingMasterReducer from './slices/company/dispensingMasterSlice';
import dispenseMaterialReducer from './slices/company/dispenseMaterialSlice';



export const store = configureStore({
  reducer: {
    adminauth: authReducer,
    adminCompanies: adminCompaniesReducer,
    adminRoles: adminRoleReducer,
    adminStaff: adminStaffReducer,


    // COmpaniues

    companyRoles: companyRoleReducer,
    branches: branchReducer,
    branchUsers: branchUserReducer,
    suppliers: supplierReducer,
    accountingTaxes: taxesReducer,
    accountingUnits: unitsReducer,
    rawCategories: rawCategoryReducer,
    rawProduct: rawProductReducer,
    finalProduct: finalProductReducer,
    customers: customerReducer,
    tenders: tenderReducer,
    finalCategory: finalCategoryReducer,
    purchases: purchasesReducer,
    rawMaterialStock: rawMaterialReducer,
    tasks: taskReducer,
    bills: billsReducer,
    creditNotes: creditNotesReducer,
    assets: assetsReducer,
    productAttribute: productAttributeReducer, // Assuming attributes are part of finalProductSlice
    brands: brandReducer,
    dispensingMaster: dispensingMasterReducer,
    dispenseMaterial: dispenseMaterialReducer,

  }
});
